import { Component, Vue } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'
import request from '@/helpers/request'
import imgLogoru from '@/assets/tizer-logo.png'
import imgLogoen from '@/assets/viaSteps_logo.svg'
export interface Restore {
    newPassword: string,
    repeatedPassword: string,
    code: string | any
}

@Component
export default class RestorePassword extends Vue{

    $refs!: {
        restoreForm: ElForm
    }

    public imgLogo = {
        ru: imgLogoru,
        en: imgLogoen
    }

    restoreForm: Restore = {
        newPassword: '',
        repeatedPassword: '',
        code: ''
    }

    getTranslatedWord(word: string) {
        return `${this.$t(word)}`
    }

    restoreRules: any = {
        newPassword: [{ required: true, trigger: 'blur' }],
        repeatedPassword: [{ validator: 
            (rule: any, value: string, callback: any) => {
                if (value === '') {
                    callback(new Error(this.getTranslatedWord('user.please_repeat_password')))
                } else if (value !== this.restoreForm.newPassword) {
                    callback(new Error(this.getTranslatedWord('user.passwords_dont_match')))
                } else {
                    callback()
                }
        }, trigger: 'blur' }]
    }
    
    loading: boolean = false

    mounted(){
        this.loading = false
    }

    handleSubmit() {
        this.restoreForm.code = this.$route.query.info
        this.$refs['restoreForm'].validate(async (valid: boolean) => {
            if (!valid) return
            this.loading = true
            try {
                const response = await request({
                    url: '/users/reset',
                    method: 'POST',
                    data: this.restoreForm
                })
                this.$message.success(this.getTranslatedWord('user.password_successfully_changed'))
                this.$router.push('/login')
            } catch (error) {
                this.$message.error(this.getTranslatedWord('user.code_expired'))
            }
            this.loading = false
        })
    }
}